import React, { useState } from "react";
import { Button, Carousel, Col, Container, Row } from "react-bootstrap";
import ContactCommon from "../components/ContactCommon";

// Image
import abdulRehmanBaloch from "../assets/images/team/abdul-rehman.webp";
import laibaRehman from "../assets/images/team/laiba-rehman.webp";
import awaisAslam from "../assets/images/team/awais-aslam.webp";

import emmaRichards from "../assets/images/users/emma-richards.jpg";
import danielMorgan from "../assets/images/users/daniel-morgan.jpg";
import ahmedKhan from "../assets/images/users/ahmed-khan.jpg";

interface TeamData {
  name: string;
  role: string;
  pic?: string;
  image?: string;
  description?: string;
}

interface IndicatorsData {
  picture: string;
}

const teamMembers: TeamData[] = [
  {
    name: "Abdul Rehman Baloch",
    role: "Founder & Full Stack Engineer",
    pic: abdulRehmanBaloch,
  },
  {
    name: "Laiba Rehman",
    role: "Graphic Designer & Wordpress Developer",
    pic: laibaRehman,
  },
  {
    name: "Rana Awais",
    role: "UI/UX Designer & Lead Developer",
    pic: awaisAslam,
  },
  // {
  //   name: "Maryam Mujahid",
  //   role: "Web Developer",
  //   pic: maryamMujahid,
  // },
];
const clientData: TeamData[] = [
  { name: "Emma Richards", role: "Business Owner (UK)", description: "Abdul Rehman delivered our business website exactly as promised — fast, responsive, and modern. Communication was excellent throughout the project.", image: emmaRichards },
  { name: "Daniel Morgan", role: "Founder, Tech Startup (NZD)", description: "Very professional. He built a custom admin panel for our services platform and integrated everything perfectly. Highly recommended!", image: danielMorgan },
  { name: "Ahmed Khan", role: "Entrepreneur (PK)", description: "Abdul is my go-to developer for dashboards, mobile apps, and backend APIs.  Great problem solver and always delivers on time.", image: ahmedKhan },
];

const Section1 = () => {
  const indicatorsData: IndicatorsData[] = [
    { picture: emmaRichards },
    { picture: danielMorgan },
    { picture: ahmedKhan },
  ];
  const [activeIndex, setActiveIndex] = useState<number>(0);

  const handleSelect = (selectedIndex: any) => {
    setActiveIndex(selectedIndex);
  };

  const renderIndicators = () => {
    return (indicatorsData || [])?.map(
      (item: IndicatorsData, index: number) => (
        <button
          type="button"
          data-bs-target="#carouselExampleIndicators"
          className={index === activeIndex ? "active " : ""}
          onClick={() => handleSelect(index)}
          key={index}
        >
          <img
            src={item.picture}
            alt=""
            className="testi-img img-fluid object-fit-cover rounded-circle mx-auto d-block"
          />
        </button>
      )
    );
  };

  return (
    <React.Fragment>
      {/* Team */}
      <section className="section" id="team">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8}>
              <div className="text-center">
                <h2 className="heading-title-title letter-spacing_4 text-uppercase">
                  Meet our Team
                </h2>
                <p className="heading-title-desc text-muted mt-4">
                  A passionate team dedicated to building impactful digital solutions.
                </p>
              </div>
            </Col>
          </Row>

          <Row className="mt-5 pt-3">
            {(teamMembers || [])?.map((item: TeamData, index: number) => {
              return (
                <Col lg={3} key={index}>
                  <div className="business-team-box text-center mt-4">
                    <div className="business-team-img">
                      <img src={item.pic} className="img-fluid rounded rounded-4" style={{ width: '100%', height: '275px', objectFit: 'cover', filter: 'grayscale(0.85)' }} alt="" />
                    </div>
                    <div className="business-team-content mt-4">
                      <h4 className="f-15 text-uppercase letter-spacing_2">
                        {item.name}
                      </h4>
                      <p className="mb-0 text-muted f-12">{item.role}</p>
                    </div>
                  </div>
                </Col>
              );
            })}
          </Row>
        </Container>
      </section>

      {/* CTA */}
      <section className="section business-bg-cta">
        <div className="bg-overlay"></div>
        <Container>
          <Row>
            <Col lg={12}>
              <div className="business-cta-box text-center text-white">
                <h4 className="business-cta-title letter-spacing_4 text-uppercase">
                  Let’s Build Something Great Together
                </h4>
                <p className="f-15 mt-4">
                  Have an idea or project in mind? Let’s discuss how we can turn it into a powerful digital product.
                </p>

                <div className="mt-4 pt-3">
                  <Button
                  target="_blank"
                    href="https://wa.me/923134561816?text=Hi%20Abdul%20Rehman%2C%20I%20have%20a%20project%20idea%20and%20want%20to%20discuss%20it."
                    className="btn-md btn-white"
                  >
                    Let's Talk
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Client */}
      <section className="section business-client" id="client">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8}>
              <div className="text-center">
                <h2 className="heading-title-title letter-spacing_4 text-uppercase">
                  Our Clients
                </h2>
                <p className="heading-title-desc text-muted mt-4">
                  Trusted by startups, small businesses, and growing companies across the UK, NZ, and Pakistan. Here’s what some of my clients say about working with our team.
                </p>
              </div>
            </Col>
          </Row>
          <Row className=" mt-5 pt-4">
            <Col lg={12}>
              <div
                id="carouselExampleIndicators"
                className="carousel business-carousel slide"
                data-bs-ride="carousel"
              >
                <div className="carousel-indicators  d-flex">
                  {renderIndicators()}
                </div>
                <Carousel
                  id="carouselExampleIndicators"
                  className="carousel business-carousel slide"
                  onSelect={handleSelect}
                  activeIndex={activeIndex}
                  indicators={false}
                >
                  {(clientData || [])?.map((item: TeamData, index: number) => (
                    <Carousel.Item key={index}>
                      <div className="business-testi-box text-center mt-4">
                        <p className="text-muted line-height_1_8 f-17">{item.description}</p>
                        <h5 className="f-15 text-uppercase letter-spacing_2 mt-4">
                          {item.name}
                        </h5>
                        <p className="text-muted mb-0 f-12">{item.role}</p>
                      </div>
                    </Carousel.Item>
                  ))}
                </Carousel>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <hr />

      {/* Blog */}
      {/* <Blog /> */}

      <hr />

      {/* Contact */}
      <ContactCommon />
    </React.Fragment>
  );
};

export default Section1;
